// ========== ACHIEVEMENT ==========
export const GET_ACHIEVEMENTS = "GET_ACHIEVEMENTS";
export const GET_ACHIEVEMENTS_SUCCESS = "GET_ACHIEVEMENTS_SUCCESS";
export const GET_ACHIEVEMENTS_FAIL = "GET_ACHIEVEMENTS_FAIL";

export const ADD_ACHIEVEMENT = "ADD_ACHIEVEMENT";
export const ADD_ACHIEVEMENT_SUCCESS = "ADD_ACHIEVEMENT_SUCCESS";
export const ADD_ACHIEVEMENT_FAIL = "ADD_ACHIEVEMENT_FAIL";

export const UPDATE_ACHIEVEMENT = "UPDATE_ACHIEVEMENT";
export const UPDATE_ACHIEVEMENT_SUCCESS = "UPDATE_ACHIEVEMENT_SUCCESS";
export const UPDATE_ACHIEVEMENT_FAIL = "UPDATE_ACHIEVEMENT_FAIL";

export const DELETE_ACHIEVEMENT = "DELETE_ACHIEVEMENT";
export const DELETE_ACHIEVEMENT_SUCCESS = "DELETE_ACHIEVEMENT_SUCCESS";
export const DELETE_ACHIEVEMENT_FAIL = "DELETE_ACHIEVEMENT_FAIL";

export const SET_ACHIEVEMENT_FIELD_ERRORS = "SET_ACHIEVEMENT_FIELD_ERRORS";
